import { Channel, Inbox, InboxChannelType } from '@spike/omnichannel-model';

export const channelFromInboxType = (channelType: InboxChannelType): Channel =>
    channelType === 'sms' ? 'sms' : 'email';

export const inboxForChannel = (inboxes: Array<Inbox>, channel: Channel): Inbox | undefined => {
    const matches = inboxes.filter(inbox => channelFromInboxType(inbox.channelType) === channel);

    if (channel === 'email') {
        return matches.find(inbox => inbox.channelType === 'email_ses') ?? matches[0];
    }

    return matches[0];
};

/**
 * Only for channels the business connects with its own account (phase 2: Gmail, Outlook, WhatsApp),
 * where the brand is something they recognise and sign in to. Twilio and SES are our infrastructure:
 * the marketplace has no account with either, so we show the number or the address instead.
 */
export const providerLabel = (inbox: Inbox): string => {
    switch (inbox.channelType) {
        case 'email_gmail':
            return 'Gmail';
        case 'whatsapp_twilio':
            return 'WhatsApp';
        default:
            return inbox.channelType;
    }
};
